import i18n from 'modules/core/lib/i18n'

export const dynamicOptions = () => [
  {
    label: i18n.t('performance_process.reviews.workplace'),
    id: 'by_locations',
  },
  {
    label: i18n.t('performance_process.reviews.team'),
    id: 'by_teams',
  },
]
